module.exports = __webpack_public_path__ + "img/2.903e87e7.png";